import React from 'react';
import PropTypes from 'prop-types';
import './Video.css';

export default function YouTubeVideo(props) {
  return (
    <div className="youtube-iframe-container">
      <iframe title={props.title} src={props.src} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
    </div>
  );
}

YouTubeVideo.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
